import { findCourseDescriptorFromParents } from '@pm2/sitemap-utils';

function isDescriptorInsideCourse(sitemap, currentDescriptor) {
  const courseDescriptor = findCourseDescriptorFromParents(sitemap, currentDescriptor);
  return courseDescriptor && currentDescriptor?.type !== "Course";
}

export { isDescriptorInsideCourse };
//# sourceMappingURL=util.is-inside-course.js.map
